<template>
  <div class="wrapper">
    <div class="container">
      <img src="@/assets/images/banner.png" class="banner" />
      <div class="section">
        <p>注册可能会花费您3-5分钟时间~</p>
        <p>如果您是企业、个体户，请您准备好营业执照、法人身份证、结算收款银行卡。</p>
        <p>如果您是个人用户，请您提前准备好您的身份证、结算收款银行卡。</p>
      </div>
      <div class="section qualifi-section">
        <p>支付、结算全流程由易宝支付提供，查看《<span class="remarks" @click="toPreviewImg">中华人民共和国支付业务资质</span>》。</p>
      </div>
    </div>
    <div class="footer-bar"></div>
    <div class="footer">
      <div class="submit-btn" @click="goBack">我知道了</div>
    </div>
    <ContactBtn />
  </div>
</template>


<script>
import { ImagePreview } from 'vant';
import { getCategory } from '@/api/baseinfo';
export default {
  name: 'guide',
  data () {
    return {
      docHt: document.body.offsetHeight > 0 ? document.body.offsetHeight : document.body.clientHeight,
      imgUrl: undefined
    }
  },
  created() {
    this.getQualificationImg();
  },
  methods: {
    toPreviewImg() {
      if(!this.imgUrl) return this.Toast('支付业务资质图片加载失败，请稍后再试~');
      ImagePreview({
        images: this.imgUrl ? [this.imgUrl] : [],
        closeable: true	
      })
    },
    goBack() {
      let shopCode = sessionStorage.getItem('shopCode');
      let distributionType = sessionStorage.getItem('distributionType');
      let partnerCode = sessionStorage.getItem('partnerCode');
      sessionStorage.setItem('distributionFlag', true);
      if(!shopCode&&!distributionType) return this.$router.replace('/distribution/login');
      if(shopCode&&distributionType) {
        if(!partnerCode){
          this.$router.replace('/distribution/login?shopCode='+shopCode+'&distributionType='+distributionType)
        } else {
          this.$router.replace('/distribution/login?shopCode='+shopCode+'&distributionType='+distributionType+'&partnerCode='+partnerCode)
        }
      } else {
        if(distributionType) {
          if(!partnerCode){
            this.$router.replace('/distribution/login?distributionType=' + distributionType)
          } else {
            this.$router.replace('/distribution/login?distributionType=' + distributionType+'&partnerCode='+partnerCode)
          }
        }
        if(shopCode){
          if(!partnerCode){
            this.$router.replace('/distribution/login?shopCode='+shopCode)
          } else {
            this.$router.replace('/distribution/login?shopCode='+shopCode+'&partnerCode='+partnerCode)
          }
        }
      }
    },
    getQualificationImg() {
      getCategory('CS20220610102').then(res => {
        if(res.data && res.data.length > 0) {
          this.imgUrl = res.data[0].constantImg;
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width:750px){
  .container{
    padding-top: 1px;
    padding-bottom: 50px;
    position: relative;
  }
  .banner{
    width: 16.75rem;
    height: 8.2rem;
    display: block;
    margin: 1.2rem auto .8rem;
    border-radius: .8rem;
  }
  .section{
    width: 16.75rem;
    margin: 0 auto 1.25rem;
    p{
      line-height: 1.5;
      font-size: .7rem;
      color: #222;
      text-align: left;
      margin-bottom: .25rem;
      .remarks{
        font-size: .7rem;
        color: $base-color;
        cursor: pointer;
      }
    }
    .service-list{
      margin-bottom: 1.25rem;
      li{
        line-height: 1.5;
        font-size: .7rem;
        color: #222;
        text-align: left;
        margin-bottom: .25rem;
        font-weight: 600;
      }
    }
  }
  .qualifi-section{
    margin-bottom: 0;
  }
  .footer {
    bottom: 0;
  }
}
@media screen and (min-width:750px){
  .banner{
    width: 335px;
    height: 164px;
    display: block;
    margin: 24px auto 16px;
    border-radius: 16px;
  }
  .section{
    width: 335px;
    margin: 0 auto 25px;
    p{
      line-height: 1.5;
      font-size: 14px;
      color: #222;
      text-align: left;
      margin-bottom: 5px;
      NaNpxarks{
        font-size: 14px;
        color: $base-color;
        cursor: pointer;
      }
    }
    .service-list{
      margin-bottom: 25px;
      li{
        line-height: 1.5;
        font-size: 14px;
        color: #222;
        text-align: left;
        margin-bottom: 5px;
        font-weight: 600;
      }
    }
  }
  .qualifi-section{
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/distribution/guide.vue